var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfEpub = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(180 40 40)",
    fill: "#C5EEDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.7059C13 15.5447 13 13.9641 13.9958 12.9821C14.9917 12 16.5944 12 19.8 12H23.2C26.4056 12 28.0083 12 29.0042 12.9821C30 13.9641 30 15.5447 30 18.7059V24.2941C30 27.4553 30 29.0359 29.0042 30.0179C28.0083 31 26.4056 31 23.2 31H19.8C16.5944 31 14.9917 31 13.9958 30.0179C13 29.0359 13 27.4553 13 24.2941V18.7059Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 16.7071C20.6834 16.3166 21.3166 16.3166 21.7071 16.7071L23.4076 18.4076C23.7981 18.7981 23.7982 19.4311 23.4078 19.8217L21.7578 21.4724C21.4975 21.7329 21.0753 21.7329 20.815 21.4725C20.5547 21.2122 20.5546 20.7903 20.8148 20.5299L21.6149 19.7293C21.9542 19.3898 21.9541 18.8395 21.6147 18.5001C21.2752 18.1606 20.7248 18.1606 20.3853 18.5001L18.5925 20.2929C18.202 20.6834 18.202 21.3166 18.5925 21.7071L20.2929 23.4075C20.6834 23.798 21.3166 23.798 21.7071 23.4075L24.5859 20.5286C24.8463 20.2683 25.2683 20.2683 25.5286 20.5286C25.789 20.789 25.789 21.211 25.5286 21.4714L21.7071 25.2929C21.3166 25.6834 20.6834 25.6834 20.2929 25.2929L16.7071 21.7071C16.3166 21.3166 16.3166 20.6834 16.7071 20.2929C17.9024 19.0976 19.0976 17.9024 20.2929 16.7071Z",
    fill: "#1D1D1D",
    stroke: "#C5EEDF",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 28C11.5222 28 10 26.4988 10 24.6471V17.9412C10 13.7263 10 11.6188 11.3278 10.3094C12.6556 9 14.7926 9 19.0667 9H23.6C25.4778 9 27 10.5012 27 12.3529",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfEpub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-epub.8b9a3c2a91d66a72f9716bb52b720a8d.svg";